import { NewConsignmentService } from "./service";

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(NewConsignmentService);
});
